module.exports = __webpack_public_path__ + "img/gb.4a9cf084.png";